<template>
  <div class="commerical-modal">
    <b-container>
      <div class="commerical">
        <button class="button" v-b-modal.modal-com>Получить коммерческое предложение</button>
        <p class="promise" v-html="promise"></p>
      </div>
      <b-modal
        content-class="com-content"
        body-class="com-body"
        v-slot:default="{ hide }"
        class="hui"
        id="modal-com"
        size="xl"
        centered
        hide-footer
        hide-header
      >
        <b-overlay :show="showOverlay" spinner-variant="warning" spinner-type="grow" rounded="true">
          <div class="accept" v-if="accept">
            <p>
              <span class="green fw-600">Ваш запрос принят</span>, коммерческое предложение сформировано
              <br />и в ближайшее время поступит на указанный вами адрес электронной почты.
            </p>
            <button @click="hide()" class="submit button">ok</button>
          </div>
          <form v-if="!accept" class="modal-form" @submit.prevent="submitHandler">
            <div class="input-inner">
              <b-alert
                :show="($v.email.$dirty && !$v.email.required) || ($v.email.$dirty && !$v.email.email)"
                variant="danger"
              >Некорректный E-mail!</b-alert>
              <input
                v-model.trim="email"
                type="mail"
                placeholder="E-mail"
                :class="{invalid: (($v.email.$dirty && !$v.email.required) || ($v.email.$dirty && !$v.email.email))}"
              />
            </div>
            <div class="input-inner">
              <b-alert
                :show="($v.name.$dirty && !$v.name.required)"
                variant="danger"
              >Некорректное имя!</b-alert>
              <input
                v-model.trim="name"
                type="text"
                placeholder="Имя"
                :class="{invalid: ($v.name.$dirty && !$v.name.required)}"
              />
            </div>
            <div class="input-inner">
              <b-alert
                :show="$v.tel.$dirty && !$v.tel.numeric"
                variant="danger"
              >Телефон не может содержать буквы!</b-alert>
              <input
                v-model.trim="tel"
                type="tel"
                placeholder="Телефон (необязательно)"
                :class="{invalid: ($v.tel.$dirty && !$v.tel.numeric)}"
              />
            </div>
            <button class="submit button" type="submit">Отправить</button>
          </form>
          <button class="close-modal" @click="hide()">
            <img src="@/assets/images/x.svg" alt />
          </button>
        </b-overlay>
      </b-modal>
    </b-container>
  </div>
</template>
<script>
import { required, email, numeric } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      email: "",
      name: "",
      tel: "",
      showOverlay: false,
      accept: false
    };
  },
  props: {
    promise: String
  },
  validations: {
    email: {
      required,
      email
    },
    name: {
      required
    },
    tel: {
      numeric
    }
  },
  methods: {
    async submitHandler() {
      this.showOverlay = true;
      
      const response = await fetch('/send.php', {
        method: 'POST',
        body: JSON.stringify({email: this.email, name: this.name, tel: this.tel}),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      // if (response.status === 200) {
        this.showOverlay = false;
        if (this.$v.$invalid) {
          this.$v.$touch();
            return;
        }
        this.accept = true;
      // } else {
      // @TODO: show error
      // }
    }
  }
};
</script>
